module.exports = __webpack_public_path__ + "img/南宁熠美整形.34c6856.png";